import React, { FC } from 'react';

// import { YbCoreSnackbar } from '@yubi/yb-core-snackbar-v3';

import { TextDirection } from '@yubi/phoenix-provider';

export interface SnackbarV3Props {
  testID?: string;
  direction?: TextDirection;
  variant?: 'fixed' | 'floated-with-shadow' | 'floated-without-shadow';
  type?: 'info' | 'error' | 'success' | 'caution' | 'special';
  showIcon?: boolean;
  customIcon?: string;
  title?: string;
  info: string;
  infoType?: 'min' | 'max';
  buttonText?: string;
  onButtonClick?: () => void;
  linkText?: string;
  linkURL?: string;
  showClose?: boolean;
  onClose?: () => void;
  autoClose?: boolean;
  closeDelay?: number;
}

const AlertViewV3: FC<SnackbarV3Props> = ({
  variant,
  title,
  info,
  type,
  infoType,
  showIcon,
  showClose,
  autoClose,
  closeDelay,
  buttonText,
  onButtonClick,
}) => {
  return (
    <></>
    // <YbCoreSnackbar
    //   variant={variant}
    //   title={title}
    //   info={info}
    //   type={type}
    //   infoType={infoType}
    //   showIcon={showIcon}
    //   showClose={showClose}
    //   autoClose={autoClose}
    //   closeDelay={closeDelay}
    //   buttonText={buttonText}
    //   onButtonClick={onButtonClick}
    // />
  );
};

export default AlertViewV3;
